import { ClaimsGetAdapter } from '../../../adapter';

export default async function ClaimsGetUseCase(event) {
    // prepare data
    const { id, page, claimsStaff } = event;

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/get'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/get'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/get`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/get`;

    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/claim/get';

    const payload = {
        refId: id,
        refTable: 'txn_uploaded_policy',
        page: page || 1,
        size: 5,
        claimsStaff: claimsStaff
    };

    // handle request
    const result = await ClaimsGetAdapter(endpoint, JSON.stringify(payload));

    return result;
}
